import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { groupBy, uniq } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./TimeSlotHeatmap.css";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "none",
    fontSize: theme.typography.pxToRem(12),
    border: "none",
    padding: 0,
    boxShadow: "none",
  },
}));

const weekDays=['Sun','Mon','Tues','Wed','Thurs','Fri','Sat']
const dayMap={
  Sun:'Sunday',
  Mon:'Monday',
  Tues:'Tuesday',
  Wed:'Wednesday',
  Thurs:'Thursday',
  Fri:'Friday',
  Sat:'Saturday',
}

const getColorClass = (record) => {  
  if(record?.isOverbooked||record?.utilizationPercentage>100){
    return 'high'
  }
  if(record?.utilizationPercentage>=50&&record?.utilizationPercentage<=100){
    return 'medium'
  }
  return 'low'
};

export default function TimeSlotHeatmap() {
  const dispatch = useDispatch();
  const { loading, enhancedTimeSlotHeatmap } = useSelector((state) => state.appointmentTypes);
  const [view, setView] = useState("Weekly");
  const [timeSlots, setTimeSlots] = useState([]);
  const [hourSlotGroupedList,setHourSlotGroupedList] = useState({})

  useEffect(()=>{
    if(!enhancedTimeSlotHeatmap||!enhancedTimeSlotHeatmap?.heatmapData||loading) return
    const timeList=enhancedTimeSlotHeatmap?.heatmapData?.map((li)=>li?.hourSlot??'')
    const uniqTimeList=uniq(timeList)
    setTimeSlots(uniqTimeList)
    const groupedList=groupBy(enhancedTimeSlotHeatmap?.heatmapData, 'hourSlot')
    setHourSlotGroupedList(groupedList)
  },[enhancedTimeSlotHeatmap])

  const getTooltipContent = (content) => {

    return (
      <div>
        {/* Header with gray background matching breedsChart */}
        <div
          className="apexcharts-tooltip-title"
          style={{
            fontFamily: "Helvetica, Arial, sans-serif",
            fontSize: "12px",
            backgroundColor: "#EBEBEB",
            color: "#000",
            padding: "8px",
            margin: 0,
          }}
        >
          {content?.hourSlot}, {content?.day}          
        </div>
        <div
            className="apexcharts-tooltip-series-group"
            style={{
              order: 1,
              display: "flex",
              backgroundColor: "#fff",
              padding: "8px",
            }}
          >
            <div
              className="apexcharts-tooltip-text"
              style={{
                fontFamily: "Helvetica, Arial, sans-serif",
                fontSize: "12px",
                color: "#000",
              }}
            >
              <div className="apexcharts-tooltip-y-group">                  
                  <span className="apexcharts-tooltip-text-y-value">
                  {`${Number(content?.utilizationPercentage)?.toFixed(2)}% utilized, ${content?.bookedCount} cases booked, ${content?.noShowCount} no-shows`}
                  </span>
                </div>
            </div>
            </div>
      </div>
    );
  };

  return (
    <div className="heatmap-container">
      {/* <div className="heatmap-header">
        <h3>Time Slot Popularity</h3>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          size="small"
          sx={{
            backgroundColor: '#f0f2f5',
            borderRadius: '12px',
            '& .MuiToggleButtonGroup-grouped': {
              borderRadius: '7px',
              borderColor: 'transparent',
              color: '#333',
              fontWeight: 500,
              '&.Mui-selected': {
                backgroundColor: '#005EB8',
                color: '#fff',
              },
            },
          }}
        >
          <ToggleButton value="Weekly">Week</ToggleButton>
          <ToggleButton value="Monthly">Month</ToggleButton>
        </ToggleButtonGroup>
      </div> */}
      <div className="heatmap-header">
  <div className="left-section">
    <h3>Time-Slot Popularity Heatmap</h3>
  </div>

  {/* <ToggleButtonGroup
    value={view}
    exclusive
    onChange={(_, val) => val && setView(val)}
    size="small"
    sx={{
      backgroundColor: '#f0f2f5',
      borderRadius: '12px',
      '& .MuiToggleButtonGroup-grouped': {
        borderRadius: '7px',
        borderColor: 'transparent',
        color: '#333',
        fontWeight: 500,
        '&.Mui-selected': {
          backgroundColor: '#005EB8',
          color: '#fff',
        },
      },
    }}
  >
    <ToggleButton value="Weekly">Week</ToggleButton>
    <ToggleButton value="Monthly">Month</ToggleButton>
  </ToggleButtonGroup> */}
</div>

      <div className="heatmap-legend">
        <span><span className="dot high"></span> More bookings</span>
        <span><span className="dot medium"></span> Medium bookings</span>
        <span><span className="dot low"></span> Fewer bookings</span>
      </div>

      <div className="heatmap-grid">
        {/* Header Row */}
        <div className="empty-cell" />
        {weekDays?.map((day) => (
          <div className="header-cell" key={day}>{day}</div>
        ))}

        {/* Data Rows */}
        {timeSlots?.map((slot, rowIndex) => {
          const currRowData=hourSlotGroupedList?.[slot]
          return(
          <>
            <div className="time-cell">{slot}</div>
            {weekDays?.map((wd)=>{
              const matRec=currRowData?.find((li)=>li?.day?.toLowerCase()===dayMap?.[wd]?.toLowerCase())                
              const tooltipContent = getTooltipContent(
                matRec,
              );    
              return(
                <HtmlTooltip
                key={`${rowIndex}-${wd}`}
                title={tooltipContent}
                arrow
                followCursor
                placement="top"
              >
                <div
                
                className={`booking-cell ${getColorClass(matRec)}`}
              >
                {matRec?.bookedCount??0}
              </div>
              </HtmlTooltip>
              )
            })}           
          </>
        )})}
      </div>
    </div>
  );
}